import axios from "axios"
import store from '../store'

const getSkey = () => {
    try {
        const skey = sessionStorage.getItem("token")
        if (skey) {
            return skey;
        } else {
            return "";
        }
    } catch (error) {
        return "";
    }
}

const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    // timeout: 5000,
    // headers: {'X-Custom-Header': 'foobar'}
    headers: {'Authorization': getSkey()},
    // data:{},
})

// 添加请求拦截器
http.interceptors.request.use(function (config) {
    console.log("config",config)
    // 在发送请求之前做些什么
    config.cancelToken = new axios.CancelToken(function (cancel) {
        store.commit('pushToken', {cancel})
    })
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    let data = response
    // return data;
    if(data.data.code==10000){
        // 成功
    }else{
        if(data.data.message||data.data.message==''){
            window.vmm.$message.error(data.data.message)
        }
    }
    return Promise.resolve(data);
}, function (error) {
    // 对响应错误做点什么
    console.log("err",error)
    window.vmm.$message.error("请求接口失败："+error)
    return Promise.reject(error);
});

export default http